import React from "react";
import ReactDOM from "react-dom/client";
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import Stukken from "./pages/Stukken/Stukken";
import Eindredactie from "./pages/Eindredactie/Eindredactie";
import Boeken from './pages/Boeken/Boeken';
import ScrollToTop from './components/ScrollToTop'
import Achtergrond from "./pages/Achtergrond/Achtergrond";



const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <ScrollToTop/>
            <Routes>
                <Route path="/" element={<App/>}/>
                <Route path="/boeken" element={<Boeken/>}/>
                <Route path="/stukken" element={<Stukken/>}/>
                <Route path="/eindredactie" element={<Eindredactie/>}/>
                <Route path="/achtergrond" element={<Achtergrond/>}/>
            </Routes>
        </BrowserRouter>
    </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
